module.exports = __webpack_public_path__ + "img/jjfa-bj.39f07a8c.jpg";